import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { AlertTriangle } from "lucide-react";

/**
 * Confirmation dialog that requires the user to type "DELETE" before proceeding.
 * Used for both Archive (soft delete) and Permanent Delete.
 */
export function ArchiveDialog({ open, onOpenChange, title, description, confirmLabel = "Arsipkan",
  destructive = false, onConfirm, testId = "archive" }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const close = (v) => { if (!v) setText(""); onOpenChange(v); };
  const run = async () => {
    if (text.trim().toUpperCase() !== "DELETE") return;
    setBusy(true);
    try { await onConfirm(); setText(""); onOpenChange(false); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className={`h-5 w-5 ${destructive ? "text-destructive" : "text-[hsl(var(--warning))]"}`} />
            {title}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">{description}</p>
          <div className="space-y-1.5">
            <label className="text-sm font-medium">Ketik <span className="font-mono font-bold">DELETE</span> untuk konfirmasi:</label>
            <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="DELETE"
              autoFocus data-testid={`${testId}-confirm-input`} onKeyDown={(e) => { if (e.key === "Enter") run(); }} />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => close(false)} data-testid={`${testId}-cancel`}>Batal</Button>
          <Button variant={destructive ? "destructive" : "default"} onClick={run}
            disabled={busy || text.trim().toUpperCase() !== "DELETE"} data-testid={`${testId}-confirm`}>
            {busy ? "Memproses..." : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
